module.exports = {
    'uaa.version': 'UAA Version:',
    'uaa.menu.profile': 'Profile',
    'uaa.menu.administration': 'Administration',
    'uaa.menu.users': 'Users',
    'uaa.menu.roles': 'Roles',
    'uaa.menu.groups': 'Groups',
    'uaa.menu.companies': 'Districts',
    'uaa.menu.templates': 'Templates',
    'uaa.menu.audit': 'Audit',
    
    'uaa.no_data': 'No data to show.',
    'uaa.handles-403-loop.title':'Oops! Something went wrong.',
    'uaa.handles-403-loop.msg':'This page didn\'t load Index correctly. See the JavaScript console for technical details.',
    'uaa.handles-403-loop.detail': 'Loop on 403 error redirection: user doesn\'t have some permissions to view the index page, or it\'s trying to load same page multiple times without having permissions.',
    
    "core.notify_info": "Info!",
    "core.notify_error": "Error!",
    "core_notify_perms.denied": "You don't have the necessary permissions",

    "jdro_common.error_401": "Not authenticated or session expired (401)",
    "jdro_common.error_403": "Unauthorized (403)",
    "jdro_common.edit": "Edit",
    'jdro_common.action': 'Actions',
    "jdro_common.not_set_ms": "Undefined",
    "jdro_common.not_set_fm": "Undefined",
    "jdro_common.not_set_more": "Undefined",
    "jdro_common.find": "Search..",
    "jdro_common.delete": "Delete",
    "jdro_common.cancel": "Cancel",
    "jdro_common.retry": "Cancel",
    "jdro_common.save": "Save",
    "jdro_common.multiSelect.selectAll": "Select All",
    "jdro_common.multiSelect.selectNone": "Select None",
    "jdro_common.multiSelect.reset": "Reset",
    "jdro_common.multiSelect.search": "Type here to search...",
    "jdro_common.multiSelect.nothingSelected": "Nothing Selected",

    "jdro_person.notify_409_error": "Cannot create user. Email already used. Try with a different email.",
    "jdro_person.list": "User list",
    "jdro_person.add": "Add User",
    "jdro_person.add_message": "Define new user",
    "jdro_person.username": "Username",
    "jdro_person.activated": "Activated",
    "jdro_person.enabled": "Enabled",
    "jdro_person.name": "Name",
    "jdro_person.surname": "Surname",
    "jdro_person.email": "E-Mail",
    "jdro_person.company": "Company",
    "jdro_person.roles": "User roles",
    "jdro_person.group": "User groups",
    "jdro_person.password": "Password",
    "jdro_person.confirm_password": "Confirm New Password",
    "jdro_person.identity": "Identity",
    "jdro_person.information_user": "User info",
    "jdro_person.activated_user": "Select this box to enable this person to enter the system.",
    "jdro_person.new_password": "New Password",
    "jdro_person.confirm_new_password": "Conform New Password",
    "jdro_person.old_password": "Previous Password",
    "jdro_person.confirm_old_password": "Confirm Previous Password",
    "jdro_person.thumb": "Profile image",
    "jdro_person.sourceimage": "Source Image",
    "jdro_person.sourceimage_error": "File type not supported",
    "jdro_person.sourceimage_preview": "Preview",
    "jdro_person.sourceimage_cropme": "Selection area",
    "jdro_person.placeholder.username": "Enter username",
    "jdro_person.placeholder.name": "Enter username",
    "jdro_person.placeholder.surname": "Enter user surname",
    "jdro_person.placeholder.email": "Enter user email",
    "jdro_person.placeholder.company": "Select user company",
    "jdro_person.placeholder.group": "User group",
    "jdro_person.placeholder.password": "Enter password",
    "jdro_person.placeholder.old_password": "Enter previous password",
    "jdro_person.placeholder.new_password": "Enter new password",
    "jdro_person.placeholder.confirm_new_password": "Confirm new password",
    "jdro_person.placeholder.confirm_password": "Enter password again",
    "jdro_person.notify_add": "User entry result",
    "jdro_person.notify_update": "User update result",
    "jdro_person.confirm_delete": "User deletion result",
    "jdro_person.confirm_delete_this_user": "this account",
    "jdro_person.notify_delete": "User deletion result",
    "jdro_person.notify_delete_message_success": "Selected user has been successfully deleted!",
    "jdro_person.notify_delete_message_fail": " User could not be deleted. An error occurred!",
    "jdro_person.stop_paging": "All users uploaded",
    "jdro_person.button.modify_password": "Edit password",
    "jdro_person.button.not_modify_password": "Not edit password",
    "jdro_person.validate.company": "Please select company!",
    "jdro_person.validate.role": "Please select at least one role for the user!",
    "jdro_person.validate.email": "Entered email is not correct, please enter a correct email!",
    "jdro_person.validate.identity": "Username must be between 6 and 50 digits!",
    "jdro_person.validate.firstName": "The name field is required!",
    "jdro_person.validate.lastName": "The surname field is required!",
    "jdro_person.validate.email_required": "The email field is required!",
    "jdro_person.validate.email_invalid": "Entered email is incorrect!",
    "jdro_person.validate_identity.identity_required": "Please specify username!",
    "jdro_person.validate_identity.identity_max_length": "Username cannot exceed 50 digits!",
    "jdro_person.validate_identity.roles_required": "It is necessary to specify at least one role for the user",
    "jdro_person.validate_identity.old_password_validate": "Attention, previous passwords do not match!",
    "jdro_person.validate_identity.new_password_validate": "Attention, new passwords do not match!",
    "jdro_person.validate_identity.new_password_length_validate": "Attention, password has to been at least 6 char length!",
    "jdro_person.validate_identity.exist_identity": "Username already in use!",
    "jdro_person.validate_identity.old_password_valid": "Attention, previous password does not match with current password!",
    "jdro_person.validate_identity.old_password_required": "Attention, it is requested to specify previous password!",
    "jdro_person.validate_identity.password_validate": "Attention, passwords do not match!",
    "jdro_person.error.find_all": "User list cannot be downloaded!",
    "jdro_profile.tab_one": "User profile",
    "jdro_profile.tab_two": "Edit Password",
    "jdro_profile.tab_three": "Edit Thumbnail",

    "jdro_role.list": "Role list",
    "jdro_role.add": "Add Role",
    "jdro_role.add_message": "Add new role",
    "jdro_role.name_role": "Role Name",
    "jdro_role.code_role": "Role Code",
    "jdro_role.placeholder.name_role": "Enter role name",
    "jdro_role.placeholder.code_role": "Enter role code",
    "jdro_role.notify_add": "Role entry result",
    "jdro_role.notify_update": "Role update result",
    "jdro_role.confirm_delete": "Role deltion confirmation",
    "jdro_role.notify_delete": "Role deletion result",
    "jdro_role.notify_delete_message_success": "Selected role has been successfully deleted!",
    "jdro_role.notify_delete_message_fail": "Role has not been deleted, an error occurred!",
    "jdro_role.notify.exist_role_code": "It cannot be entered due to already existing role with same code!",
    "jdro_role.notify_update.exist_role_code": "It cannot be updated due to already existing role with same code!",
    "jdro_role.notify_error_get.perms": "Role cannot be found",
    "jdro_role.notify_error_get.role": "Permissions cannot be found",
    "jdro_role.error_name_message": "Role name must be longer than two digits!",
    "jdro_role.error_code_pattern": "Role name can contain only capital letters, numbers and the underscore symbol.",
    "jdro_role.error_code_message": "Role code must be longer than two digits!",
    "jdro_role.error_name_required": "Please specify role name!",
    "jdro_role.error_code_required": "Please specify role code!",
    "jdro_role.perms.IDENTITY": "Identity",
    "jdro_role.perms.ADMIN": "Admin",
    "jdro_role.perms.CREATE": "Create",
    "jdro_role.perms.READ": "Read",
    "jdro_role.perms.UPDATE": "Update",
    "jdro_role.perms.DELETE": "Delete",
    "jdro_role.perms.ASSESSMENT": "Booking assessment",
    "jdro_role.perms.ASSESSMENT_CAR": "Travel assessment",
    "jdro_role.perms.AUDIT": "Audit",
    "jdro_role.perms.BOOKABLE_RESOURCE": "Room Resource",
    "jdro_role.perms.BOOKABLE_RESOURCE_CAR": "Car Resource",
    "jdro_role.perms.BOOKABLE_RESOURCE_DESK": "Desktop Resource",
    "jdro_role.perms.COMPANY_DISTRICT": "Company Districts",
    "jdro_role.perms.GROUP": "Groups",
    "jdro_role.perms.PERSON": "Users",
    "jdro_role.perms.REPORT": "Reports",
    "jdro_role.perms.RESOURCE_OPTION": "Options",
    "jdro_role.perms.RESOURCE_OPTION_TYPE": "Option Types",
    "jdro_role.perms.ROLE": "Roles",
    "jdro_role.perms.ROLE_PERMISSION": "Role permission",
    "jdro_role.perms.SCHEDULE": "Schedules",
    "jdro_role.perms.TEMPLATE": "Templates",
    "jdro_role.perms.VOTE": "Vote",
    "jdro_role.perms.START": "Start/Stop",
    "jdro_role.perms.MULTI_SCHEDULE": "Multiple Rooms",
    "jdro_role.perms.RESOURCE_OPTION_SCHEDULE": "Booking options",
    "jdro_role.error.find_all": "Role list cannot be downloaded!",

    "jdro_company.list": "Company list",
    "jdro_company.modal.title": "Company info ",
    "jdro_company.add": "Add company",
    "jdro_company.tab_one": "Company",
    "jdro_company.tab_two": "Users",
    "jdro_company.tab_two.user": "User",
    "jdro_company.tab_two.email": "Email",
    "jdro_company.tab_two.company": "Company",
    "jdro_company.tab_two.group": "Groups",
    "jdro_company.tab_two.identity": "Identity",
    "jdro_company.tab_two.role": "Role",
    "jdro_company.tab_two.role_none": "Undefined",
    "jdro_company.tab_three": "Devices",
    "jdro_company.tab_three.device": "Serial Number",
    "jdro_company.tab_three.company": "Company",
    "jdro_company.tab_three.type": "Device Type",
    "jdro_company.tab_three.approved": "Approved",
    "jdro_company.tab_three.monitored": "Monitored",
    "jdro_company.nobody_kiosks": "Attention, this company has no device.",
    "jdro_company.nobody_persons": "Attention, this company has no user.",
    "jdro_company.add_message": "Define new company",
    "jdro_company.name_company": "Company name",
    "jdro_company.description_company": "Company description",
    "jdro_company.father": "Father company",
    "jdro_company.notify_add_suc": "Add District",
    "jdro_company.district": "Districts",
    "jdro_company.kiosks": "Devices",
    "jdro_company.placeholder.name": "Enter company name",
    "jdro_company.placeholder.description": "Enter company despcription",
    "jdro_company.confirm_delete": "Please confirm company deletion",
    "jdro_company.notify_delete": "Company deletion result",
    "jdro_company.notify_delete_message_success": "Selected company has been successfully deleted",
    "jdro_company.notify_delete_message_fail": "Selected district has not been deleted. An error occurred!",
    "jdro_company.notify_add": "Company entry result",
    "jdro_company.notify_update": "Company update result",
    "jdro_company.company_of": "Company of",
    "jdro_company.placeholder.name_company": "Company name",
    "jdro_company.validate.name.min_length": "Company name must be longer than two digits!",
    "jdro_company.validate.name": "Please specify company name!",
    "jdro_company.error.find_all": "Company list cannot be downloaded!",

    "jdro_group.list": "Groups list",
    "jdro_group.add": "Add group",
    "jdro_group.add_message": "Define new group",
    "jdro_group.name_group": "Group name",
    "jdro_group.placeholder.name_group": "Enter group name",
    "jdro_group.notify_add": "Group entry result",
    "jdro_group.notify_update": "Group update result",
    "jdro_group.confirm_delete": "Group deletion result",
    "jdro_group.notify_delete": "Group deletion result",
    "jdro_group.notify_delete_message_success": "Selected group has been successfully deleted!",
    "jdro_group.notify_delete_message_fail": "Group has not been deleted, an error occurred!",
    "jdro_group.error_title_message": "Group name must be longer than two digits!",
    "jdro_group.error.find_all": "Group list cannot be downloaded!",
   
    "jdro_audit.info.title": "Audits",
    "jdro_audit.list": "Audits list",
    "jdro_audit.modal.title": "Control information",
    "jdro_audit.level": "Level",
    "jdro_audit.data": "Data",
    "jdro_audit.category": "Category",
    "jdro_audit.user": "User",
    "jdro_audit.message": "Message",
    "jdro_audit.ip": "IP",
    "jdro_audit.stop_paging": "All audits uploaded.",
    "jdro_audit.error.find_all": "Audit list cannot be downloaded.",
    "jdro_template.list": "Template List",
    "jdro_template.add": "Add template",
    "jdro_template.back_to_list": "Go back to template list",
    "jdro_template.add_message": "Define new template",
    "jdro_template.code": "Template code",
    "jdro_template.type": "Template type",
    "jdro_template.from": "Sender",
    "jdro_template.subject": "Object",
    "jdro_template.content": "Content",
    "jdro_template.placeholder.code": "Enter template code",
    "jdro_template.placeholder.type": "Enter template type",
    "jdro_template.placeholder.from": "Enter template sender",
    "jdro_template.placeholder.subject": "Enter template object",
    "jdro_template.placeholder.content": "Enter template content",
    "jdro_template.information_template": "Template information",
    "jdro_template.confirm_delete": "Please confirm template deletion",
    "jdro_template.notify_delete": "Template deletion result",
    "jdro_template.notify_delete_message_success": "Selected template has been successfully deleted ",
    "jdro_template.notify_delete_message_fail": "Selected template has not been deleted, an error occurred!",
    "jdro_template.notify_add": "Template entry result",
    "jdro_template.notify_update": "Template update result",
    "jdro_template.notify.exist_code": "Attention, already existing template with same code!",
    "jdro_template.validate.email_required": "Email is required!",
    "jdro_template.validate.emailjdro_invalid": "Email is not correct!",
    "jdro_template.validate.type": "Type is not correct!",
    "jdro_template.validate.code": "Code is not correct!",
    "jdro_template.validate.subject": "Attention, specify the email object",
    "jdro_template.error.find_all": "Template list cannot be downloaded!",
};


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/languages/en.js
// module id = 352
// module chunks = 0